<template>
    <div id="center">
        <baidu-map :center="center" :zoom="zoom" @ready="handler" @click="getClickInfo" :scroll-wheel-zoom='true' style="height:6rem;width:12.2rem;padding: 0.1rem">
        </baidu-map>
<!--        <div id="areamap" style="height:6.5rem;"></div>-->
    </div>
</template>

<script>
  import echartMixins from "@/utils/resizeMixins";
  // 显示中国地图

  export default {
    data() {
      return {
        chart: null,
        center: {lng: 109.45744048529967, lat: 36.49771311230842},
        zoom: 13
      };
    },
    props:{
      location: Array,
    },
    mixins: [echartMixins],
    mounted() {
    },
    methods: {
      handler ({BMap, map}) {
        console.log(this.location)
        var point = new BMap.Point(this.location[0][0], this.location[0][1])
        map.setMapStyle({style:'midnight'});
        map.centerAndZoom(point, 13)
        var marker = new BMap.Marker(point) // 创建标注
        map.addOverlay(marker) // 将标注添加到地图中
        var circle = new BMap.Circle(point, 6, { strokeColor: 'Red', strokeWeight: 6, strokeOpacity: 1, Color: 'Red', fillColor: '#f03' })
        map.addOverlay(circle)
      },
      getClickInfo (e) {
        console.log(e.point.lng)
        console.log(e.point.lat)
        this.center.lng = e.point.lng
        this.center.lat = e.point.lat
      }
    }

  };
</script>

<style lang="scss">


</style>
